import type { DocTypesByPageName } from '../../../config/platformSettings';

export type TDocument = IDocumentWithTypeV2<DocTypesByPageName['clinicalstudy']>;

export const getClinicalStudyHeaderId = (documents: TDocument[], id: string, platform?: Platform): string => {
  const { _type } = documents.find(d => d._id === id) ?? {};
  if (!_type) return platform === 'polyneuro' ? 'clinicalstudy.polyneuro.title' : 'clinicalstudy.title';
  return _type ? `clinicalstudy.${_type}` : 'clinicalstudy.title';
};
